<template>
  <InteractionStep
    :disabled-next="false"
    :pending-next="pendingSave"
    @next="onSave">
    <template v-slot:content>
      <div v-if="downloadVisaLink || downloadStatementLink"
           class="check-requirements">
        <div v-if="downloadVisaLink"
             class="check-requirements__download-block">
          <h3 class="check-requirements__download-block-title">
            {{ $tInteraction('Download the Visa info PDF') }}
          </h3>
          <a :href="downloadVisaLink"
             target="_blank"

             class="check-requirements__download-block-btn  base-btn  base-btn--outline-dark">
            <span class="_one">{{ $tInteraction('Download') }}</span>
            <BaseSvg name="ico-download-2"
                     width="1.4rem"
                     height="1.4rem"/>
          </a>
        </div>
        <div v-if="downloadStatementLink"
             class="check-requirements__download-block">
          <h3 class="check-requirements__download-block-title">
            {{ $tInteraction('Download the Statement info PDF') }}
          </h3>
          <a :href="downloadStatementLink"
             target="_blank"

             class="check-requirements__download-block-btn  base-btn  base-btn--outline-dark">
            <span class="_one">{{ $tInteraction('Download') }}</span>
            <BaseSvg name="ico-download-2"
                     width="1.4rem"
                     height="1.4rem"/>
          </a>
        </div>
      </div>

      <div class="step-check-list">
        <div v-if="address"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Address') }}</span>
          <button type="button"
                  class="step-check-list__val-copy base-btn base-btn--blue-dark d-none d-sm-inline-flex"
                  @click.prevent="onCopy(address)">
            <BaseSvg name="ico-copy"
                     width="1.2rem"
                     height="1.3rem"
                     style="margin-right: 0"/>
            <span class="small-tooltip" :class="{'_show': addressCopyTooltip}">
              <BaseSvg name="ico-check"/>
              <span>{{ $tGlobal('Copied') }}</span>
            </span>
          </button>
          <div class="step-check-list__val-wrap">
            <span class="step-check-list__val">{{ address }}</span>
            <button type="button"
                    class="step-check-list__val-copy base-btn base-btn--blue-dark d-sm-none"
                    @click.prevent="onCopy(address)">
              <BaseSvg name="ico-copy"
                       width="1.2rem"
                       height="1.3rem"
                       style="margin-right: 0"/>
              <span class="small-tooltip" :class="{'_show': addressCopyTooltip}">
                <BaseSvg name="ico-check"/>
                <span>{{ $tGlobal('Copied') }}</span>
              </span>
            </button>
          </div>
        </div>
        <div v-if="data.clothing_size"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Size of shirts / T-shirts') }}</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{ data.clothing_size.name }}</span>
          </div>
        </div>
        <div v-if="data.waist"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Waist, cm') }}</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{ data.waist }}</span></div>
        </div>
        <div v-if="data.shoe_size"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Shoe size') }}</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{ data.shoe_size }}</span></div>
        </div>
        <div v-if="data.height"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Growth, cm') }}</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{ data.height }}</span></div>
        </div>
        <div v-if="data.weight"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Weight, kg') }}</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{ data.weight }}</span></div>
        </div>
        <div v-if="data.nova_poshta_fullname"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Full name for "Nova Poshta"') }}</span>
          <div class="step-check-list__val-wrap"><span
            class="step-check-list__val">{{ data.nova_poshta_fullname }}</span></div>
        </div>
        <div v-if="data.nova_poshta_phone"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Phone for "Nova Poshta"') }}</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{ data.nova_poshta_phone }}</span>
          </div>
        </div>
        <div v-if="data.nova_poshta_city"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Department of "Nova Poshta"') }}</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{ data.nova_poshta_city }}, №<span
            class="step-check-list__val-accent">{{ data.nova_poshta_number }}</span></span></div>
        </div>
      </div>
      <BaseAlert :value="error"
                 class="step-contract__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '@/axios'
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"
  import download from "@/helpers/download"

  let timerCopy

  export default {
    name: 'InteractionStepPassport2',
    mixins: [interactionStepMixin],
    data() {
      return {
        pendingSave: false,
        error: null,
        data: null,
        value: 1,
        addressCopyTooltip: false
      }
    },
    components: {
      InteractionStep
    },
    computed: {
      // dataTimeString() {
      //   const d = new Date(this.data.data)
      //   d.setHours(this.data.time_hours)
      //   d.setMinutes(this.data.time_minutes)
      //   return d.toLocaleString()
      // },
      address() {//documents_delivery_address
        // address_apartment: null
        // address_city: "м.Луцьк"
        // address_country: "Україна"
        // address_district: null
        // address_house: "95"
        // address_region: "Волинська"
        // address_street: "Вулична"
        // address_zip_code: "43000"
        //Украина, г. Житомир, ул. Киевская, 56/9, кв.46
        const data = this.data
        const region = data.address_region ? (`${data.address_region} ` + this.$tInteraction('reg') + '.') : null
        const district = data.address_district ? (`${data.address_district} ` + this.$tInteraction('area')) : null
        // const house = `${data.address_house}${data.address_house && data.address_house ? '/' : null}${data.address_house}`

        const a = [data.address_country, region, district, data.address_district, data.address_city, data.address_street, data.address_house, data.address_apartment, data.address_zip_code]
        return a.filter(a => a).join(', ')
      },
      token() {
        return this.$store.state.user.token
      },
      downloadVisaLink() {
        if (!this.data.visa_info_link) return

        return this.data.visa_info_link + `?token=${this.token}`
      },
      downloadStatementLink() {
        if (!this.data.statement_info_link) return
        return this.data.statement_info_link + `?token=${this.token}`
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, {
          approved: this.value
        }).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
      onCopy(text) {
        navigator.clipboard.writeText(text)
        this.addressCopyTooltip = true

        clearTimeout(timerCopy)
        timerCopy = setTimeout(() => {
          this.addressCopyTooltip = false
        }, 2500)
      },
      onDownloadVisa() {
        download(this.downloadVisaLink, 'visa-info', 'pdf', true, 'application/pdf')
      },
      onDownloadStatement() {
        download(this.downloadStatementLink, 'statement-info', 'pdf', true, 'application/pdf')
      }
    },
    created() {
      this.data = this.$store.state.interaction.stepData.data
    }
  }
</script>

<style scoped lang="less">
  .check-requirements {
    margin-bottom: 3rem;

    &__download-block {
      display: flex;
      align-items: center;
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__download-block-title {
      order: 2;
      margin: 0 0 0 2rem;
      font-size: 1.8rem;
    }
  }
</style>
